import React from "react";
import {
  Typography,
  Container,
  Box,
  Link,
  useTheme,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useAppSettings } from "../../contexts/AppSettingsContext";
import logo_powered_by from "../../images/logo_powered_by.png";

const Footer: React.FC = () => {
  const theme = useTheme();
  const { settings } = useAppSettings();
  
  return (
    <Box 
      component="footer" 
      sx={{ 
        py: 2,
        bgcolor: "#f5f5f7",
        borderTop: "1px solid #e0e0e0",
        width: "100%",
        position: "relative",
        bottom: 0,
        left: 0
      }}
    >
      <Container maxWidth="lg">
        <Box 
          sx={{ 
            display: "flex", 
            flexDirection: { xs: "column", md: "row" },
            justifyContent: { xs: "center", md: "space-between" },
            alignItems: { xs: "flex-start", md: "center" },
            gap: { xs: 2, md: 0 },
          }}
        >
          {/* Left - Copyright text */}
          <Typography 
            variant="body2" 
            color="text.secondary"
            sx={{ textAlign: { xs: "center", md: "left" }, width: { xs: "100%", md: "auto" } }}
          >
            © {new Date().getFullYear()} {settings.companyName}. All rights reserved.
          </Typography>
          
          {/* Middle - Powered by logo */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: { xs: "100%", md: "auto" },
              my: { xs: 1, md: 0 },
            }}
          >
            <img 
              src={logo_powered_by} 
              alt="Powered by Tranzcribe" 
              style={{ 
                height: "32px",
                maxWidth: "100%",
                maxHeight: "40px",
                width: "auto"
              }} 
            />
          </Box>
          
          {/* Right - Links */}
          <Box 
            sx={{ 
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: { xs: "center", md: "flex-start" },
              gap: { xs: 2, md: 3 },
              width: { xs: "100%", md: "auto" },
            }}
          >
            <Link 
              component={RouterLink} 
              to="/privacy-policy" 
              color="text.secondary"
              underline="hover"
              sx={{ fontSize: "0.95rem", py: { xs: 1, md: 0 }, width: { xs: "100%", md: "auto" }, textAlign: { xs: "center", md: "left" } }}
            >
              Privacy Policy
            </Link>
            <Link 
              component={RouterLink} 
              to="/terms-of-service" 
              color="text.secondary"
              underline="hover"
              sx={{ fontSize: "0.95rem", py: { xs: 1, md: 0 }, width: { xs: "100%", md: "auto" }, textAlign: { xs: "center", md: "left" } }}
            >
              Terms of Service
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 